import { Component } from "react";
import axios from 'axios';
import cookie from "react-cookie";
import { browserHistory } from "react-router";

class App extends Component {

    componentWillMount() {
    	this.configureBaseBackendUrl();
    	this.useLoginCookieIfFound();
    	//this.forwardToLoginUpon401Or403();
    	this.forwardToSignupUpon401Or403();
    }    

    useLoginCookieIfFound() {
        const jwt = cookie.load("webfinery.jwt");
        if ("undefined" !== typeof jwt) {
            axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
        }
    }

    configureBaseBackendUrl() {
    	if (process.env.NODE_ENV === "production") {
    		axios.defaults.baseURL="https://app.webfinery.com";
    	} else {
    		axios.defaults.baseURL="http://localhost:8080";
    	}
    }

    forwardToLoginUpon401Or403() {
    	axios.interceptors.response.use(
            function(config) {
                return config;
            },
            function(error) {
            	if (error.response) {
	            	if (error.response.status === 401) {
	            		browserHistory.push("/login?reason=401");
	            	}
	            	if (error.response.status === 403) {
	            		browserHistory.push("/login?reason=403");
	            	}
	            } else {
	            	// Something happened in setting up the request that triggered an Error
	            	// 401 & cors ends up here with "Network Error" message. 
	            	// Maybe Jhipster doesn't return Allow-Origin headers for errors like this.
	            	// Let's assume user has to log in
	            	//console.log("There was an error");
	            	//console.dir(error);
	            	
	            	console.log('most likely cors error', error.message);

	            	//FIXME browserHistory.push("/login?reason=error");
	            }	            
            	return Promise.reject(error);
            }
        );
    }

    forwardToSignupUpon401Or403() {
    	axios.interceptors.response.use(
            function(config) {
                return config;
            },
            function(error) {            	
            	if (error.response) {

					let requestUrl = error.response.config.url;

	            	if (error.response.status === 401) {

	            		if (!requestUrl.endsWith('/authenticate')) {
	            			browserHistory.push("/signup?reason=401");
	            		} else {
	            			//Promise.reject(error);
	            		}
	            	}
	            	if (error.response.status === 403) {

	            		if (!requestUrl.endsWith('search') && !requestUrl.endsWith('search/export')) {
	            			browserHistory.push("/signup?reason=403");
	            		} else {
	            			//ignore, it's being handled by a signup pop-up in SearchPage 
	            			//Promise.reject(error);
	            		}
	            	}
	            } else {
	            	// Something happened in setting up the request that triggered an Error
	            	// 401 & cors ends up here with "Network Error" message. 
	            	// Maybe Jhipster doesn't return Allow-Origin headers for errors like this.
	            	// Let's assume user has to log in
	            	//console.log("There was an error");
	            	//console.dir(error);
	            	
	            	console.log('most likely cors error', error.message);

	            	//FIXME browserHistory.push("/signup?reason=error");
	            }	            
            	return Promise.reject(error);
            }
        );
    }


	render() {
		return this.props.children;
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js